import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultDealerData, getDealerById, updateDealer, createDealer } from '@/api/dealers';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { getDealersRoles } from '@/api/dealers-roles';
import { getAgents } from '@/api/agents';
import { getQuery } from '@/utils';
import FileUpload from '@/components/FileUpload/index.vue';
import { AdminModule } from '@/store/modules/admin';
import { getBranches } from '@/api/locations/branches';
import { getSchemes } from '@/api/schemes';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultDealerData);
    this.loading = false;
    this.roleList = [];
    this.agentList = [];
    this.branchList = [];
    this.schemesList = [];
    this.selectedSchemes = [];
    this.logo = [];
    this.loggedInAdmin = null;
    this.isSuperAdmin = false;
    this.rules = {
      name: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        min: 3,
        max: 150,
        message: 'Length should be 3 to 150 characters',
        trigger: 'blur'
      }],
      dealersRoleId: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      code: [{
        min: 2,
        max: 25,
        message: 'Length should be 2 to 25 characters',
        trigger: ['blur']
      }],
      holdReason: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      privateMarka: [{
        max: 20,
        message: 'Maximum allowed length is 20',
        trigger: 'blur'
      }]
    };
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    this.loggedInAdmin = AdminModule;
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultDealerData);
    }
    // fetch dealer roles
    this.fetchDealersRoles();
    // fetch agents
    this.fetchAgents();
    // fetch branch
    this.fetchBranches();
    this.fetchSchemes();
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      this.logo = [];
      const data = await getDealerById(id);
      this.formData = data;
      // set logo
      this.logo.push({
        name: data.name,
        url: data.logo
      });
      if (this.formData.scheme && this.formData.scheme.length) {
        this.selectedSchemes = this.formData.scheme.map(scheme => scheme.id);
        const schemesList = [];
        this.formData.scheme.forEach(value => {
          schemesList.push({
            id: value.id,
            name: value.name
          });
        });
        this.schemesList = schemesList;
      }
      // Just for test
      const title = this.formData.name;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async fetchDealersRoles() {
    this.roleList = await getDealersRoles(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: 'eq'
      }
    }));
  }
  async fetchAgents() {
    this.agentList = await getAgents(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: 'eq'
      }
    }));
  }
  async fetchBranches() {
    this.branchList = await getBranches(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: 'eq'
      }
    }));
  }
  async fetchSchemes() {
    this.schemesList = await getSchemes(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: 'eq'
      }
    }));
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  fileUploaded(file) {
    this.formData.logo = file.response;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      this.formData.agent = {
        id: this.formData.agentId
      };
      this.formData.dealersRole = {
        id: this.formData.dealersRoleId
      };
      this.formData.branch = {
        id: this.formData.branchId
      };
      this.formData.holdBy = this.loggedInAdmin.id;
      this.formData.scheme = [];
      if (this.selectedSchemes.length > 0) {
        this.selectedSchemes.forEach(value => {
          this.formData.scheme.push({
            id: value
          });
        });
      }
      if (this.isEdit) {
        await updateDealer(this.formData.id, this.formData);
      } else {
        await createDealer(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Dealer saved successfully',
        type: 'success',
        duration: 2000
      });
      router.push('/dealers/list');
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'DealerDetail',
  components: {
    FileUpload
  }
})], default_1);
export default default_1;